import CryptoJS from 'crypto-js';

export const isEmpty = <T>(data: T): boolean => {
    if (typeof data === 'undefined' || data == null) {
        return true
    }
    if (typeof data === 'string' || Array.isArray(data)) {
        return data.length === 0
    }
    return Object.keys(data).length === 0
}

export const isNotEmpty = <T>(data: T): boolean => {
    return !isEmpty(data)
}


//字符串的单位为元
export const strToFen = (text: string): number => {
    if (isEmpty(text)) {
        return 0
    }
    let fen = parseFloat(text)
    return fen ? Math.floor(fen * 100) : 0
}

//分转换为展示为单位为元的字符串
export const showFen = (fen: number): string => {
    let yuan = fen / 100
    return yuan ? `${yuan}` : '0'
}

export const addKeyToListItem = (list: any[]): any[] => {
    if (isEmpty(list)) {
        return []
    }
    console.log(typeof list)
    const newList = list.map((item, i) => ({
        ...item,
        key: i
    }))
    return newList;
}

export const strSubstring = (str: string, n: number): string => {
    if (isEmpty(str)) {
        return str
    }
    if (str.length > n) {
        return str.substring(0, n) + "..."
    } else {
        return str
    }
}

export const formatNumber = (n: number): string => {
    let ns = n.toString()
    return ns[1] ? ns : `0${n}`
}

export const formatRangeDate = (range: string[], beginKey: string, endKey: string): {} => {
    if (isEmpty(range) || range.length !== 2) {
        return {}
    }
    let beginTime = range[0]
    let endDate = new Date(Date.parse(range[1] ?? beginTime ?? ''))
    endDate.setDate(endDate.getDate() + 1)
    const endTime = `${endDate.getFullYear()}-${formatNumber(endDate.getMonth() + 1)}-${formatNumber(endDate.getDate())}`
    return {
        [beginKey]: beginTime,
        [endKey]: endTime
    }
}

//aes加密
export function aesEcode(data: string, key: string, iv: string): string {//加密
    let keys = CryptoJS.enc.Utf8.parse(key)
    let vis = CryptoJS.enc.Utf8.parse(iv)
    let encrypt = CryptoJS.AES.encrypt(data, keys, {
        iv: vis, //iv偏移量 CBC需加偏移量
        mode: CryptoJS.mode.CBC, //CBC模式
        // mode: CryptoJS.mode.ECB, //ECB模式
        padding: CryptoJS.pad.Pkcs7 //padding处理
    });
    // debugger
    return encrypt.toString(); //加密完成后，转换成字符串
}

export function tagMaptoOptions(dataMap: any[]): any[] {
    let options = []
    for (let k in dataMap) {
        if (k + '' === '0') {
            options.push({
                label: '全部',
                value: 0
            })
        } else {
            options.push({
                label: dataMap[k].msg,
                value: parseInt(k)
            })

        }
    }
    return options
}

interface ValidateMessageParams {
    label?: string;
}

interface StringValidationParams {
    maxLength?: number;
}

interface ValidateMessages {
    required: (value: any, params: ValidateMessageParams) => string;
    string: {
        maxLength: (params: StringValidationParams, messageParams: ValidateMessageParams) => string;
    };
}
// export const validateMessages = {
//     required: (_, { label }) => `${label}不能为空`,
//     string: {
//         maxLength: ({ maxLength }, { label }) => `${label}不能超过${maxLength}个字符`,
//     }
// }

export const validateMessages: ValidateMessages = {
    required: (_, { label }) => `${label}不能为空`,
    string: {
        maxLength: ({ maxLength }, { label }) => `${label}不能超过${maxLength}个字符`,
    }
};